<hw-page-header header="term.di-01.header" class="page-header"></hw-page-header>
<nz-content class="main">
  <hw-table header="term.di-01.header">
    <div headerContent>
      <button [routerLink]="['/dictionaries/add']" class="button" nz-button nzType="secondary">
        {{ 'core.btn.add' | translate }}
      </button>
    </div>
    <nz-table #basicTable [nzData]="items" nzSize="small" nzHideOnSinglePage="true" nzShowSizeChanger="false">
      <thead>
        <tr>
          <th>{{ 'term.di-01.id' | translate }}</th>
          <th>{{ 'term.di-01.title' | translate }}</th>
          <th>{{ 'term.di-01.name' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of basicTable.data">
          <td>
            <a [routerLink]="['/dictionaries/view', row.id]">{{ row.id }}</a>
          </td>
          <td>{{ row.title | localName }}</td>
          <td>{{ row.names | localName }}</td>
        </tr>
      </tbody>
    </nz-table>
  </hw-table>
</nz-content>
